var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "form-group mb-4" },
    [
      _c("label", {
        attrs: { for: _vm.name },
        domProps: { innerHTML: _vm._s(_vm.label) }
      }),
      _vm._v(" "),
      _c("file-pond", {
        class: { "is-invalid": _vm.error !== "" },
        attrs: {
          name: _vm.name,
          "label-idle":
            "Klik hier of zet bestanden neer om te uploaden <br/> <small>(5 MB per file)</small>",
          files: _vm.value,
          "allow-multiple": _vm.multiple,
          maxFileSize: "5MB"
        },
        on: { updatefiles: _vm.handleFilePondInit }
      }),
      _vm._v(" "),
      _vm.error !== ""
        ? _c("div", {
            staticClass: "invalid-feedback",
            domProps: { innerHTML: _vm._s(_vm.error) }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// /home/dev/tafelgasten.outlawz.dev/web/app/themes/expert/node_modules/vue-loader/lib/loaders/templateLoader.js?{}!/home/dev/tafelgasten.outlawz.dev/web/app/themes/expert/node_modules/vue-loader/lib?{}!./scripts/vue/fields/FileField.vue?vue&type=template&id=54a1757c&
// module id = 375
// module chunks = 0